import { render, staticRenderFns } from "./MySubmissions.vue?vue&type=template&id=44755ec0&scoped=true"
import script from "./MySubmissions.vue?vue&type=script&lang=js"
export * from "./MySubmissions.vue?vue&type=script&lang=js"
import style0 from "./MySubmissions.vue?vue&type=style&index=0&id=44755ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44755ec0",
  null
  
)

export default component.exports